import React from "react";

export default function accountIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#B9BABF" />
      <circle cx="12" cy="12" r="11" fill="#0F1015" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 18.7169C5.5554 17.1012 7.01541 15.9108 8.77214 15.7258C9.76862 16.3699 10.9517 16.747 12.2248 16.747C13.4979 16.747 14.681 16.3699 15.6775 15.7258C17.4263 15.91 18.881 17.0904 19.442 18.6949C18.3781 19.942 16.9973 20.9104 15.4242 21.4756V19.9507C15.4242 19.36 14.9476 18.8828 14.3577 18.8828H10.0919C9.502 18.8828 9.02543 19.36 9.02543 19.9507V21.4851C7.45062 20.9246 6.06729 19.9603 5 18.7169ZM11.1584 21.9748C10.7964 21.9349 10.4405 21.8746 10.0919 21.7952V20.4847C10.0919 20.191 10.3318 19.9507 10.6251 19.9507C10.9184 19.9507 11.1584 20.191 11.1584 20.4847V21.9748ZM7.34241 12.4754H6.8925C6.59922 12.4754 6.35927 12.2351 6.35927 11.9414V8.73768C6.35927 8.444 6.59922 8.20372 6.8925 8.20372H7.34241C8.16559 6.3182 10.0386 5 12.2248 5C14.4111 5 16.284 6.3182 17.1072 8.20372H17.5571C17.8504 8.20372 18.0904 8.444 18.0904 8.73768V11.9414C18.0904 12.2351 17.8504 12.4754 17.5571 12.4754H17.1072C16.284 14.3609 14.4111 15.6791 12.2248 15.6791C10.0386 15.6791 8.16559 14.3609 7.34241 12.4754ZM9.82528 8.20372C8.94211 8.20372 8.22558 8.80108 8.22558 9.53861V10.3395C8.22558 12.1083 9.65864 13.5433 11.425 13.5433H13.0247C14.791 13.5433 16.2241 12.1083 16.2241 10.3395V9.53861C16.2241 8.80108 15.5075 8.20372 14.6244 8.20372H9.82528ZM13.2913 20.4847C13.2913 20.191 13.5312 19.9507 13.8245 19.9507C14.1178 19.9507 14.3577 20.191 14.3577 20.4847C14.3577 20.7783 14.1178 21.0186 13.8245 21.0186C13.5312 21.0186 13.2913 20.7783 13.2913 20.4847Z"
        fill="#B9BABF"
      />
      <path
        d="M9.44746 8.74615C8.67859 9.03903 8.66588 10.2015 8.66588 10.2015C8.51494 12.7887 11.051 13.2648 12.156 12.9908L12.1394 12.9766C10.9311 11.9394 10.1951 11.3077 11.617 8.63834C10.6467 8.47665 9.69001 8.65376 9.44746 8.74615Z"
        fill="#B9BABF"
        stroke="black"
        stroke-width="0.0411347"
      />
    </svg>
  );
}
